export default __webpack_public_path__ + "static/media/userManagementicon.48ae0f18.svg";